import React from 'react';
import { m } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
import { scrollToId } from '../../utils/scroll';
import { transformationRows, transformationFooterStats } from '../../data/transformation';
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-217" data-mp="2ffdpkivf2uhn">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-218" data-mp="2bfbx90bkndf1">
        <SectionTag icon="⚡" data-id="element-219" data-mp="2bh6g893a8vgh">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-220" data-mp="26nbpilp9fg7w">
          Tus domingos no deberían terminar así...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-221" data-mp="2z4edc3qk4y7f">
          Un domingo por la noche, buscando ejercicios sueltos en YouTube que no sabes si van a funcionar el
          martes con tus chavales.
        </p>

        <div className="mt-6 rounded-2xl border border-lime/20 bg-lime/5 p-5 text-left sm:p-6" data-id="element-222" data-mp="159hg3v2k4p0j">
          <p className="font-heading text-sm font-semibold uppercase tracking-wide text-lime" data-id="element-223" data-mp="1a5y5stpenbfq">
            Recupera tus domingos
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-224" data-mp="we1qjq8u4w0r">
            <span className="font-semibold text-white" data-id="element-225" data-mp="10fn3tcpa7cbh">El coste real:</span> Planificar manualmente te
            quita de 3 a 5 horas por semana. Es el equivalente a un mes entero de trabajo al año quemado en
            YouTube, grupos de WhatsApp de entrenadores y dudas mentales.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-226" data-mp="hilu5eks8o17">
        <div className="space-y-4" data-id="element-227" data-mp="hj3ykyhlm8k7">
          {transformationRows.map((row, i) => <m.div key={row.title} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="rounded-2xl border border-white/10 bg-bg-secondary p-5 sm:p-6" data-id="element-228" data-mp="27wcn0msjikmf" data-mpi={i}>
              <p className="mb-3 text-xs font-semibold uppercase tracking-wider text-muted" data-id="element-229" data-mp="3bsvgwj35cwfv">
                {row.title} · {row.n}
              </p>
              <div className="grid gap-4 sm:grid-cols-2" data-id="element-230" data-mp="36v3q5se8ngd9">
                <div className="flex items-start gap-3" data-id="element-231" data-mp="7ef70gjqfs6s">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-danger/15" data-id="element-232" data-mp="7e5byejtyuu8">
                    <XIcon size={14} className="text-danger" data-id="element-233" data-mp="3ffua9rrer4s" />
                  </div>
                  <div data-id="element-234" data-mp="3upmx2jne6vfp">
                    <p className="text-xs font-semibold uppercase tracking-wide text-danger" data-id="element-235" data-mp="3pso6uc6un8ms">Antes</p>
                    <p className="mt-1 text-sm leading-relaxed text-muted" data-id="element-236" data-mp="r2e6uwcrdexf">{row.before}</p>
                  </div>
                </div>
                <div className="flex items-start gap-3" data-id="element-237" data-mp="mawfn00jespn">
                  <div className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-success/15" data-id="element-238" data-mp="tn2h6thr0zzm">
                    <CheckIcon size={14} className="text-success" data-id="element-239" data-mp="yldpv0wb54g9" />
                  </div>
                  <div data-id="element-240" data-mp="13kqlob55pluz">
                    <p className="text-xs font-semibold uppercase tracking-wide text-success" data-id="element-241" data-mp="13kguwlcafao8">Ahora</p>
                    <p className="mt-1 text-sm leading-relaxed text-white" data-id="element-242" data-mp="17nmx9hwa4hpf">{row.after}</p>
                  </div>
                </div>
              </div>
            </m.div>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-243" data-mp="1hjq9xhorbyqm">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-244" data-mp="1mbrhiqazd1ab">Quiero dejar de improvisar</PrimaryButton>
        </div>

        <div className="mt-8" data-id="element-245" data-mp="1rb45jedl8eeh">
          <ScrollHintTable minWidth="480px" data-id="element-246" data-mp="1rab8j54fl39j">
            <div className="grid grid-cols-3 divide-x divide-white/10" data-id="element-247" data-mp="1vcppfjojhsy6">
              {transformationFooterStats.map(stat => <div key={stat.label} className="flex flex-col items-center gap-1 px-3 py-6 text-center" data-id="element-248" data-mp="20ckf5jwkwchn">
                  <span className="font-heading text-xl font-bold text-lime sm:text-2xl" data-id="element-249" data-mp="1mnhcrwae96n8">{stat.value}</span>
                  <span className="text-xs text-muted sm:text-sm" data-id="element-250" data-mp="1imp3x45fp3rh">{stat.label}</span>
                </div>)}
            </div>
          </ScrollHintTable>
        </div>
      </div>
    </section>;
}